import { Box, Skeleton } from '@mui/material';
import React from 'react';

interface HubCircularImageProps {
  isLoading: boolean;
  imageSrc: string | null;
  firstName?: string;
  lastName?: string;
  size?: number;
  borderRadius?: string | number;
}

export const HubCircularImage: React.FC<HubCircularImageProps> = ({
  isLoading,
  imageSrc,
  firstName,
  lastName,
  size = 40,
  borderRadius = '50%',
}) => {
  if (!isLoading && imageSrc) {
    return (
      <Box
        component="img"
        src={imageSrc}
        alt={firstName && lastName ? `${firstName} ${lastName}` : 'Image'}
        sx={{
          width: size,
          height: size,
          borderRadius,
          objectFit: 'cover',
          border: '1px solid white',
        }}
      />
    );
  }

  return (
    <Skeleton
      variant="circular"
      width={size}
      height={size}
      animation="wave"
      sx={{
        border: '1px solid white',
      }}
    />
  );
};

export default HubCircularImage;
